export default __webpack_public_path__ + "static/media/Zyloric.cbf61d9b.jpg";